import * as actionTypes from "./actionTypes";

export const setMobileFormsValue = (name, value) => {
  return {
    type: actionTypes.SET_MOBILE_FORMS_VALUE,
    data: { name, value },
  };
};

export const removeMobileFormsValue = (name) => {
  return {
    type: actionTypes.REMOVE_MOBILE_FORMS_VALUE,
    data: { name },
  };
};

export const setMobileFormsValuesFromUserDetail = (userDetail) => {
  return {
    type: actionTypes.SET_MOBILE_FORMS_VALUES_FROM_USER_DETAIL,
    data: userDetail,
  };
};

export const removeMobileFormValues = async (form, dispatch) => {
  const dispatchPromises = Object.keys(form).map(async (input) => {
    await new Promise((resolve) => {
      dispatch(
        setMobileFormsValue(input, {
          value: "",
          validation: "",
          error: "",
        })
      );
      resolve(null);
    });
  });

  await Promise.all(dispatchPromises);
};
